import { UseQueryOptions } from '@tanstack/react-query';

import { SpecialistCalendlyLink } from '../useCalendlyLinks/useCalendlyLinks.interface';
import useCalendlyLinks from '../useCalendlyLinks';

function findSpecialistByRole(data: SpecialistCalendlyLink[], role: string): SpecialistCalendlyLink | undefined {
    return data.find((item) => item.role_name === role);
}

export default function useCalendlyLinksByRole(
    role: string,
    options?: UseQueryOptions<SpecialistCalendlyLink[], unknown, SpecialistCalendlyLink | undefined>
) {
    return useCalendlyLinks<SpecialistCalendlyLink | undefined>({
        ...options,
        select: (data) => findSpecialistByRole(data, role),
    });
}
